type ReportDisplayParams = {
  show_accounts_as?: string
  show_account_numbers?: string
}

export default function reportDisplayParams(): ReportDisplayParams {
  const pageParams = new URLSearchParams(window.location.search)
  const out: ReportDisplayParams = {}

  const showAccountsAs = pageParams.get('show_accounts_as')
  if (showAccountsAs) {
    out.show_accounts_as = showAccountsAs
  }

  const showAccountNumbers = pageParams.get('show_account_numbers')
  if (showAccountNumbers !== null) {
    out.show_account_numbers = showAccountNumbers
  }

  return out
}
